import { Ref } from 'vue';

export const DEFAULT_CARD_WIDTH_WITH_MARGIN = 166;
// Buffer: fetch extra cards beyond the visible count so a scroll or resize
// doesn't immediately hit an empty slot.
export const DEFAULT_BUFFER_CARDS = 5;

export default function useCardLimitInRow(
  rowRef: Ref<HTMLElement | null>,
  getFallbackLimit: () => number,
  getCardWidthWithMargin: () => number = () => DEFAULT_CARD_WIDTH_WITH_MARGIN,
  getBufferCards: () => number = () => DEFAULT_BUFFER_CARDS,
) {
  return (): number => {
    const rowWidth = rowRef.value?.clientWidth || 0;
    const visibleCards = Math.floor(rowWidth / getCardWidthWithMargin());
    return visibleCards > 0 ? visibleCards + getBufferCards() : getFallbackLimit();
  };
}
